import MainLayout from '../layouts/MainLayout';
import Home from '../pages/Home.vue'

import TermnialLearningObjective from '../pages/soppbe/IdentifyMasterDataElements/TerminalLearningObject.vue';
import ArmyFinancialManagementAndComptroller from '../pages/soppbe/IdentifyMasterDataElements/ArmyFinancialManagementAndComptroller.vue';
import ArmyFinancialManagementAndComptrollerCont from '../pages/soppbe/IdentifyMasterDataElements/ArmyFinancialManagementAndComptrollerCont.vue';
import ArmyFinancialManagementAndComptrollerCont2 from '../pages/soppbe/IdentifyMasterDataElements/ArmyFinancialManagementAndComptrollerCont2.vue';
import StandardFinancialInformationStructure from '../pages/soppbe/IdentifyMasterDataElements/StandardFinancialInformationStructure.vue';
import LOAExplainedThroughACreditCard from '../pages/soppbe/IdentifyMasterDataElements/LOAExplainedThroughACreditCard.vue';
import LOAExplainedThroughAPersonalCheck from '../pages/soppbe/IdentifyMasterDataElements/LOAExplainedThroughAPersonalCheck.vue';
import StandardArmyLineofAccounting from '../pages/soppbe/IdentifyMasterDataElements/StandardArmyLineofAccounting.vue';
import DepartmentCode021 from '../pages/soppbe/IdentifyMasterDataElements/DepartmentCode021.vue';
import ApplicationofFunds202011D20 from '../pages/soppbe/IdentifyMasterDataElements/ApplicationofFunds202011D20.vue';
import StatesofAppropriation from '../pages/soppbe/IdentifyMasterDataElements/StatesofAppropriation.vue';
import FunctionalAreaElementExample from '../pages/soppbe/IdentifyMasterDataElements/FunctionalAreaElementExample.vue';

import UnexpiredState from '../pages/soppbe/IdentifyMasterDataElements/UnexpiredState.vue';
import ExpiredState from '../pages/soppbe/IdentifyMasterDataElements/ExpiredState.vue';
import ClosedState from '../pages/soppbe/IdentifyMasterDataElements/ClosedState.vue';
import StatesofanAppropriationExamples from '../pages/soppbe/IdentifyMasterDataElements/StatesofanAppropriationExamples.vue';
import ApplicationofFunds from '../pages/soppbe/IdentifyMasterDataElements/ApplicationofFunds.vue';
import FundCenter from '../pages/soppbe/IdentifyMasterDataElements/FundCenter.vue';
import FundCenterCont from '../pages/soppbe/IdentifyMasterDataElements/FundCenterCont.vue';
import FunctionalArea from '../pages/soppbe/IdentifyMasterDataElements/FunctionalArea.vue';
import FunctionalAreaCont from '../pages/soppbe/IdentifyMasterDataElements/FunctionalAreaCont.vue';
import CostElementCommitmentItem from '../pages/soppbe/IdentifyMasterDataElements/CostElementCommitmentItem.vue';
import USStandardGeneralLedgerAccount from '../pages/soppbe/IdentifyMasterDataElements/USStandardGeneralLedgerAccount.vue';
import GeneralLedgerAccountCategories from '../pages/soppbe/IdentifyMasterDataElements/GeneralLedgerAccountCategories.vue';
import TheBasic6DigitUSSGLAccountsClassification from '../pages/soppbe/IdentifyMasterDataElements/TheBasic6DigitUSSGLAccountsClassification.vue';
import GeneralLedgerStructure from '../pages/soppbe/IdentifyMasterDataElements/GeneralLedgerStructure.vue';
import CommitmentItem2617 from '../pages/soppbe/IdentifyMasterDataElements/CommitmentItem2617.vue';
import FundedPrograms from '../pages/soppbe/IdentifyMasterDataElements/FundedPrograms.vue';
import WorkBreakdownStructureWBSElement from '../pages/soppbe/IdentifyMasterDataElements/WorkBreakdownStructureWBSElement.vue';
import InternalOrders from '../pages/soppbe/IdentifyMasterDataElements/InternalOrders.vue';
// import router2

import secondaryRouter from './secondaryRoute.js';

let routes = [
    {
        path: '',
        title: 'Home',
        icon: 'home',
        component: MainLayout,
        children: [
          { path: '/', name: 'home', title: 'Home', component: Home, props: true },
        ]
    },
    {
      path: '/ppbe',
      title: 'Identify Master Data Elements',
      icon: 'layers',
      redirect: '/ppbe/UnexpiredState',
      component: MainLayout,
      children: [
        { 
          path: '/ppbe/TermnialLearningObjective',
          title: 'Termnial Learning Objective',
          name: 'TermnialLearningObjective',
          component: TermnialLearningObjective,
        },
        {
          path: '/ppbe/ArmyFinancialManagementAndComptroller',
          title: 'Army Financial Management & Comptroller',
          name: 'ArmyFinancialManagementAndComptroller',
          component: ArmyFinancialManagementAndComptroller,
        },
        {
          path: '/ppbe/ArmyFinancialManagementAndComptrollerCont',
          title: 'Army Financial Management & Comptroller Cont',
          name: 'ArmyFinancialManagementAndComptrollerCont',
          component: ArmyFinancialManagementAndComptrollerCont,
        },
        {
          path: '/ppbe/ArmyFinancialManagementAndComptrollerCont2',
          title: 'Army Financial Management & Comptroller Cont 2',
          name: 'ArmyFinancialManagementAndComptrollerCont2',
          component: ArmyFinancialManagementAndComptrollerCont2,
        },
        {
          path: '/ppbe/StandardFinancialInformationStructure',
          title: 'Standard Financial Information Structure [SFIS (ess-fis)]',
          name: 'StandardFinancialInformationStructure',
          component: StandardFinancialInformationStructure,
        },
        {
          path: '/ppbe/LOAExplainedThroughACreditCard',
          title: 'LOA Explained Through a Credit Card',
          name: 'LOAExplainedThroughACreditCard',
          component: LOAExplainedThroughACreditCard,
        },
        {
          path: '/ppbe/LOAExplainedThroughAPersonalCheck',
          title: 'LOA Explained Through a Personal Check',
          name: 'LOAExplainedThroughAPersonalCheck',
          component: LOAExplainedThroughAPersonalCheck,
        },
        {
          path: '/ppbe/StandardArmyLineofAccounting',
          title: 'Standard Army Line of Accounting',
          name: 'StandardArmyLineofAccounting',
          component: StandardArmyLineofAccounting,
        },
        {
          path: '/ppbe/DepartmentCode021',
          title: 'Department Code: 021',
          name: 'DepartmentCode021',
          component: DepartmentCode021,
        },
        {
          path: '/ppbe/ApplicationofFunds202011D20',
          title: 'Application of Funds: 202011D20_',
          name: 'ApplicationofFunds202011D20',
          component: ApplicationofFunds202011D20,
        },
        {
          path: '/ppbe/StatesofAppropriation',
          title: 'States of Appropriation',
          name: 'StatesofanAppropriation',
          component: StatesofAppropriation,
        },
        { 
          path: '/ppbe/UnexpiredState',
          title: 'Unexpired State',
          name: 'unexpiredstate',
          component: UnexpiredState,
        },
        { 
          path: '/ppbe/ExpiredState',
          title: 'Expired State',
          name: 'expiredstate',
          component: ExpiredState,
        },
        { 
          path: '/ppbe/ClosedState',
          title: 'Closed State',
          name: 'closedstate',
          component: ClosedState,
        },
        { 
          path: '/ppbe/StatesofanAppropriationExamples',
          title: 'States of an Appropriation Examples',
          name: 'StatesofanAppropriationExamples',
          component: StatesofanAppropriationExamples,
        },
        { 
          path: '/ppbe/ApplicationofFunds',
          title: 'Application of Funds (Cont.)',
          name: 'ApplicationofFunds',
          component: ApplicationofFunds,
        },
        { 
          path: '/ppbe/FundCenter',
          title: 'Fund Center (A76VV)',
          name: 'FundCenter',
          component: FundCenter,
        },
        { 
          path: '/ppbe/FundCenterCont',
          title: 'Fund Center (Cont.)',
          name: 'FundCenterCont',
          component: FundCenterCont,
        },
        {
          path: '/ppbe/FunctionalArea',
          title: 'Functional Area',
          name: 'FunctionalArea',
          component: FunctionalArea,
        },
        {
          path: '/ppbe/FunctionalAreaCont',
          title: 'Functional Area (Cont)',
          name: 'FunctionalAreaCont',
          component: FunctionalAreaCont,
        },
        {
          path: '/ppbe/FunctionalAreaElementExample',
          title: 'Functional Area Element Example',
          name: 'FunctionalAreaElementExample',
          component: FunctionalAreaElementExample,
        },
        {
          path: '/ppbe/CostElementCommitmentItem',
          title: 'Cost Element / Commitment Item',
          name: 'CostElementCommitmentItem',
          component: CostElementCommitmentItem,
        },
        {
          path: '/ppbe/USStandardGeneralLedgerAccount',
          title: 'US Standard General Ledger Account (GLAC) (6100)',
          name: 'USStandardGeneralLedgerAccount',
          component: USStandardGeneralLedgerAccount,
        },
        {
          path: '/ppbe/GeneralLedgerAccountCategories',
          title: 'General Ledger Account Categories',
          name: 'GeneralLedgerAccountCategories',
          component: GeneralLedgerAccountCategories,
        },
        {
          path: '/ppbe/TheBasic6DigitUSSGLAccountsClassification',
          title: 'The Basic 6-Digit USSGL Accounts Classification',
          name: 'TheBasic6DigitUSSGLAccountsClassification',
          component: TheBasic6DigitUSSGLAccountsClassification,
        },
        {
          path: '/ppbe/GeneralLedgerStructure',
          title: 'General Ledger Structure',
          name: 'GeneralLedgerStructure',
          component: GeneralLedgerStructure,
        },
        {
          path: '/ppbe/CommitmentItem2617',
          title: 'Commitment Item (2617)',
          name: 'CommitmentItem2617',
          component: CommitmentItem2617,
        },
        {
          path: '/ppbe/FundedPrograms',
          title: 'Funded Programs',
          name: 'FundedPrograms',
          component: FundedPrograms,
        },
        {
          path: '/ppbe/WorkBreakdownStructureWBSElement',
          title: 'Work Breakdown Structure (WBS) Element',
          name: 'WorkBreakdownStructureWBSElement',
          component: WorkBreakdownStructureWBSElement,
        },
        {
          path: '/ppbe/InternalOrders',
          title: 'Internal Orders',
          name: 'InternalOrders',
          component: InternalOrders,
        },

      ]
    }
];

secondaryRouter.map((route) => {
  routes[1].children.push(route);
});

export default routes;